/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentSystemKnowledgeAccessQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentSystemKnowledgeAccessQuery = { agentSystemKnowledgeAccess: { __typename: 'AgentSystemKnowledgeAccessResult', admin: boolean } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const AgentSystemKnowledgeAccessDocument = gql`
    query AgentSystemKnowledgeAccess {
  agentSystemKnowledgeAccess {
    __typename
    ... on AgentSystemKnowledgeAccessResult {
      admin
    }
  }
}
    `;

/**
 * __useAgentSystemKnowledgeAccessQuery__
 *
 * To run a query within a React component, call `useAgentSystemKnowledgeAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentSystemKnowledgeAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSystemKnowledgeAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentSystemKnowledgeAccessQuery(baseOptions?: Apollo.QueryHookOptions<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>(AgentSystemKnowledgeAccessDocument, options);
      }
export function useAgentSystemKnowledgeAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>(AgentSystemKnowledgeAccessDocument, options);
        }
export function useAgentSystemKnowledgeAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>(AgentSystemKnowledgeAccessDocument, options);
        }
export type AgentSystemKnowledgeAccessQueryHookResult = ReturnType<typeof useAgentSystemKnowledgeAccessQuery>;
export type AgentSystemKnowledgeAccessLazyQueryHookResult = ReturnType<typeof useAgentSystemKnowledgeAccessLazyQuery>;
export type AgentSystemKnowledgeAccessSuspenseQueryHookResult = ReturnType<typeof useAgentSystemKnowledgeAccessSuspenseQuery>;
export type AgentSystemKnowledgeAccessQueryResult = Apollo.QueryResult<AgentSystemKnowledgeAccessQuery, AgentSystemKnowledgeAccessQueryVariables>;